"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.surveyTypesAsNames = void 0;
exports.surveyTypesAsNames = {
    DEGREE_PROGRAM_SURVEY: 'HowULearn',
    COURSE_SURVEY: 'HowUStudy',
    HUL: 'HowULearn',
    HUS: 'HowUStudy',
    HUP: 'PhD',
    HUT: 'HowUTeach'
};
